export class DownloadableCardHTMLElement extends HTMLElement {

    constructor() {
        super();
        this.clickHandler = this.clickHandler.bind(this);
    }

    private clickHandler(e): void {
        window.dataLayer.push({
            event: 'form_submit',
            eventCategory: 'form_download',
            eventAction: 'click_to_download_file',
            eventLabel: `language_${this.getAttribute('data-language')}`,
            privacy_consent: this.getAttribute('data-consent').toString(),
            title: this.querySelector('h2').textContent || 'null'
        });
    }
    
    public connectedCallback(): void {
        window.dataLayer = window.dataLayer || [];
        this.parentElement.addEventListener('click', this.clickHandler);
    }

    public disconnectedCallback(): void {
        this.parentElement.removeEventListener('click', this.clickHandler);
    }
}